import { motion } from "framer-motion";
import { useI18n } from "../context/I18nContext";

const STEPS = [
  { n: "01", t: "p1t", x: "p1x" },
  { n: "02", t: "p2t", x: "p2x" },
  { n: "03", t: "p3t", x: "p3x" },
  { n: "04", t: "p4t", x: "p4x" },
];

export const Process = () => {
  const { t } = useI18n();
  return (
    <section id="process" data-testid="process" className="bg-white py-24 md:py-36 px-6 lg:px-10">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-16 md:mb-24">
          <p className="font-sans text-gold text-[11px] tracking-luxury uppercase mb-5">{t("process.label")}</p>
          <h2 className="font-serif text-navy text-4xl md:text-6xl leading-tight">
            {t("process.hA")} <span className="italic text-gold">{t("process.hB")}</span>
          </h2>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-4 gap-y-14 md:gap-8">
          <div className="hidden md:block absolute top-[38px] left-[12.5%] right-[12.5%] h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />
          {STEPS.map((s, i) => (
            <motion.div key={s.n} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: i * 0.12 }} data-testid={`process-step-${i + 1}`} className="relative text-center px-4">
              <div className="relative z-10 mx-auto w-[76px] h-[76px] rounded-full bg-white border border-gold/40 flex items-center justify-center mb-6">
                <span className="font-serif text-gold text-2xl">{s.n}</span>
              </div>
              <h3 className="font-serif text-navy text-2xl mb-3">{t(s.t)}</h3>
              <p className="font-sans text-navy/50 text-sm leading-relaxed max-w-[240px] mx-auto">{t(s.x)}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
